<template>
  <content-loader :height="260" preserveAspectRatio="none">
    <!-- 1 -->
    <rect x="0" y="40" rx="4" ry="4" width="150" height="20" />
    <rect x="0" y="80" rx="4" ry="4" width="180" height="10" />
    <rect x="0" y="100" rx="4" ry="4" width="180" height="10" />
    <!-- 2 -->
    <rect x="210" y="40" rx="4" ry="4" width="150" height="20" />
    <rect x="210" y="80" rx="4" ry="4" width="180" height="10" />
    <rect x="210" y="100" rx="4" ry="4" width="180" height="10" />
    <!-- 3 -->
    <rect x="0" y="140" rx="4" ry="4" width="150" height="20" />
    <rect x="0" y="180" rx="4" ry="4" width="180" height="10" />
    <rect x="0" y="200" rx="4" ry="4" width="180" height="10" />
    <!-- 4 -->
    <rect x="210" y="140" rx="4" ry="4" width="150" height="20" />
    <rect x="210" y="180" rx="4" ry="4" width="180" height="10" />
    <rect x="210" y="200" rx="4" ry="4" width="180" height="10" />
  </content-loader>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  name: "resources-loading-skeleton",
  components: { ContentLoader }
}
</script>

<style scoped>
</style>